import { render, staticRenderFns } from "./ConsignmentPackage.vue?vue&type=template&id=a875b162"
import script from "./ConsignmentPackage.vue?vue&type=script&lang=js"
export * from "./ConsignmentPackage.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentPackage.vue?vue&type=style&index=0&id=a875b162&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports